import React from 'react';
import {useState, useEffect} from 'react';
import '../componentes/printinscripcion.css';
import Casa from '../assets/casailustracion1.svg'
import Logo from '../assets/logo san nicolas.svg';
import '../componentes/registroexitoso.css';
import Swal from 'sweetalert2';
import {
    Container, Row, Col
} from 'react-bootstrap'

import Cookies from "universal-cookie";
const ImprimirInscripcionPage = () => {
    const cookies = new Cookies();
    useEffect(() => {
        if (cookies.get('user') == undefined) {
            exito()
        } else {
        exito1()
        }
        
    }, [])
    const exito = () => {
        Swal.fire({
            title: "Registro creado exitosamente",
            html: `<img src=${Casa} />`,
            confirmButtonText: "Entendido",
            confirmButtonColor: "#0477AD",
          

            width: 438,
            customClass: {popup: 'registro',
                  
                        }
        })
    }
    const exito1 = () => {
        Swal.fire({
            title: "Registro editado exitosamente",
            html: `<img src=${Casa} />`,
            confirmButtonText: "Entendido",
            confirmButtonColor: "#0477AD",
          

            width: 438,
            customClass: {popup: 'registro',
                  
                        }
        })
    }
    return (
        
        <div className='bodyprincipal'>
            <div className='contenido'>
               <img
                src={Logo}
                alt="logo"
                className="logo"
              />
              <div className='nombre'> 
            <div>
                <div>
                    Nombre del titular: {cookies.get('nombre')} {cookies.get('apellido')}<br />
                    DNI: {cookies.get('dni')}
                </div>
            
          
            </div>
         <div className='texto'>
                Ya estás inscripto en el Registro Único de Acceso a la Vivienda de la Municipalidad de San Nicolás.
                Tu inscripción te permite ser candidato para participar de los próximos
                sorteos de viviendas que realicemos.
                Recordá que previo a cada sorteo, publicaremos los requisitos necesarios
                para acceder.
                Podrás encontrar más información en www.sannicolasciudad.gob.ar
            </div>
          </div>
            </div>
        </div>
    )
}


export default ImprimirInscripcionPage